<template>
  <section class="c-section c-section--panel-profile">
    <h2 class="fs-medium w-medium fs-30 mb-4">
      Editar perfil
    </h2>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="c-profile">
          <b-tabs>
            <b-tab active>
              <template #title>
                <span class="fs-21">
                  <Icon icon="clarity:user-line"/>
                </span>
                Datos personales
              </template>
              <div class="c-profile__container">
                <h2>
                  Datos personales
                </h2>

                <Alert v-if="alert.message" :type="alert.type" :message.sync="alert.message"/>

                <p class="sec-medium fs-16 w-regular">
                  Foto de perfil
                </p>
                <div class="c-form-group mb-3">
                  <div
                    v-if="!profile.avatar.url"
                    class="c-form-group mb-4"
                    :class="{ 'c-form-group--error': $v.profile.avatar.$error }"
                  >
                    <label
                      for="añadir-imagen"
                      class="c-form-group__file"
                      :class="{'loading' : profile.avatar.file}"
                    >
                      {{attachmentAvatarName}}
                    </label>
                    <input
                      @change="avatarFileChanged($event)"
                      type="file"
                      id="añadir-imagen"
                      class="d-none"
                    />

                    <div class="c-form-group__error" v-if="!$v.profile.avatar.required">
                      Imagen requerida
                    </div>
                  </div>
                  <div
                    v-else
                    class="d-flex flex-column align-items-center flex-md-row
                      justify-content-center"
                  >
                    <figure class="c-avatar-file me-4 mb-2 mb-md-0">
                      <img
                        :src="profile.avatar.url"
                        alt=""
                        class="w-100 h-100 of--cover"
                      />
                    </figure>
                    <a
                      @click.prevent="deleteAvatar()"
                      href=""
                      class="d-flex c-profile__link"
                    >
                      <span class="fs-16 d-flex me-2 align-items-center">
                        <Icon icon="uiw:delete"/>
                      </span>
                      Eliminar imágen
                    </a>
                  </div>
                </div>

                <div class="c-form-group mb-3">
                  <div
                    class="c-form-group mb-4"
                    :class="{ 'c-form-group--error': $v.profile.firstName.$error }"
                  >

                    <p class="mb-3 sec-medium fs-16 w-regular">
                      Nombres
                    </p>

                    <input
                      type="text"
                      class="c-form-group__input"
                      v-model.trim="$v.profile.firstName.$model"
                    />

                    <div class="c-form-group__error" v-if="!$v.profile.firstName.required">
                      Nombres requeridos
                    </div>
                  </div>

                  <div
                    class="c-form-group mb-4"
                    :class="{ 'c-form-group--error': $v.profile.lastName.$error }"
                  >

                    <p class="mb-3 sec-medium fs-16 w-regular">
                      Apellidos
                    </p>

                    <input
                      type="text"
                      class="c-form-group__input"
                      v-model.trim="$v.profile.lastName.$model"
                    />

                    <div class="c-form-group__error" v-if="!$v.profile.lastName.required">
                      Apellidos requeridos
                    </div>
                  </div>
                </div>
                <button
                  @click="updateProfile()"
                  class="c-button w-100"
                  :class="[updateButtonProfileClass, {'loading' : profile.isLoading}]"
                  :disabled="!isChangedProfile || profile.isLoading"
                >
                  <p class="mb-0 text-center w-100">
                    Guardar cambios

                    <span class="c-button__spinner ms-2">
                      <Icon icon="eos-icons:loading" />
                    </span>
                  </p>
                </button>
              </div>
            </b-tab>

            <b-tab>
              <template #title>
                <span class="fs-21">
                  <Icon icon="mdi-light:lock-unlocked"/>
                </span>
                Seguridad
              </template>
              <div class="c-profile__container">
                <h2 class="fs-21 w-sbold sec-medium mb-4">
                  Seguridad
                </h2>

                <Alert v-if="alert.message" :type="alert.type" :message.sync="alert.message"/>

                <p class="sec-medium fs-16 w-regular mb-2">
                  Actual contraseña
                </p>
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.password.current.$error }"
                >
                  <input
                    type="password"
                    class="c-form-group__input"
                    v-model.trim="$v.password.current.$model"
                    placeholder="Contraseña"
                  />

                  <div class="c-form-group__error" v-if="!$v.password.current.required">
                    Contraseña actual vacía
                  </div>
                </div>
                <p class="sec-medium fs-16 w-regular mb-2">
                  Nueva contraseña
                </p>
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.password.new.$error }"
                >
                  <input
                    type="password"
                    class="c-form-group__input"
                    v-model.trim="$v.password.new.$model"
                    placeholder="Contraseña"
                  />

                  <div class="c-form-group__error" v-if="!$v.password.new.required">
                    Contraseña nueva vacía
                  </div>
                  <div class="c-form-group__error" v-else-if="!$v.password.new.minLength">
                    La contraseña debe tener minimo
                    {{$v.password.new.$params.minLength.min}} caracteres.
                  </div>
                </div>
                <p class="sec-medium fs-16 w-regular mb-2">
                  Confirmar contraseña
                </p>
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.password.confirmNew.$error }"
                >
                  <input
                    type="password"
                    class="c-form-group__input"
                    v-model.trim="$v.password.confirmNew.$model"
                    placeholder="Contraseña"
                  />

                  <div class="c-form-group__error" v-if="!$v.password.confirmNew.required">
                    Debe confirmar la nueva contraseña
                  </div>
                  <div class="c-form-group__error" v-else-if="!$v.password.confirmNew.samePrevious">
                    Las contraseñas no coinciden
                  </div>
                </div>
                <div>
                  <button
                    @click="updatePassword()"
                    class="c-button w-100"
                    :class="[updateButtonPasswordClass, {'loading' : password.isLoading}]"
                    :disabled="!isChangedPassword || password.isLoading"
                  >
                    <p class="mb-0 text-center w-100">
                      Guardar cambios

                      <span class="c-button__spinner ms-2">
                        <Icon icon="eos-icons:loading" />
                      </span>
                    </p>
                  </button>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
} from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isChangedProfile: false,
      isChangedPassword: false,

      profile: {
        firstName: '',
        lastName: '',
        avatar: {
          file: null,
          url: '',
        },

        isLoading: false,
      },

      password: {
        current: '',
        new: '',
        confirmNew: '',

        isLoading: false,
      },

      alert: {
        type: '',
        message: '',
      },
    };
  },
  validations: {
    profile: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      avatar: {
        file: {
          required: requiredIf(function file() {
            return !this.profile.avatar.file;
          }),
        },
      },
    },

    password: {
      current: {
        required,
      },
      new: {
        required,
        minLength: minLength(5),
      },
      confirmNew: {
        required,
        samePrevious: function validateConfirmedPassword() {
          return this.password.new === this.password.confirmNew;
        },
      },
    },
  },
  components: {
    Alert: () => import(/* webpackChunkName: "ui-alert" */'../../components/ui/Alert.vue'),
  },
  computed: {
    userData() {
      return this.$store.getters.stateUser;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },

    attachmentAvatarName() {
      let extension = '';
      let name = '';

      if (this.profile.avatar.file) {
        extension = this.profile.avatar.file.name.split('.');
        extension = extension[extension.length - 1];

        if (this.profile.avatar.file.name.length > 15) {
          name = this.profile.avatar.file.name
            .substring(0, 15);

          name = `${name}....${extension}`;
        } else {
          name = this.profile.avatar.file.name;
        }
      }

      return (!this.profile.avatar.file)
        ? '+ Añadir imagen de perfil'
        : name;
    },
    updateButtonProfileClass() {
      return (this.isChangedProfile) ? 'c-button--primary' : 'c-button--gray';
    },
    updateButtonPasswordClass() {
      return (this.isChangedPassword) ? 'c-button--primary' : 'c-button--gray';
    },
  },
  watch: {
    profile: {
      handler() {
        this.isChangedProfile = true;
      },
      deep: true,
    },
    password: {
      handler() {
        this.isChangedPassword = true;
      },
      deep: true,
    },
  },
  created() {
    this.profile = {
      ...this.profile,
      firstName: this.userData.first_name,
      lastName: this.userData.last_name,
      avatar: {
        url: this.userData?.avatar?.url,
      },
    };

    window.setTimeout(() => {
      this.isChangedProfile = false;
    }, 100);
  },
  methods: {
    ...mapActions(['logOut']),

    avatarFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.profile.avatar = {
          file: null,
          url: '',
        };

        return;
      }

      this.profile.avatar = {
        file: files[0],
      };
    },
    deleteAvatar() {
      this.profile.avatar = {
        file: null,
        url: '',
      };
    },

    updateProfile() {
      this.$v.profile.$touch();

      if (!this.$v.profile.$invalid) {
        const request = `${process.env.VUE_APP_API}/users/${this.userData.id}/profile`;
        const formData = new FormData();

        formData.append('lastName', this.profile.lastName);
        formData.append('firstName', this.profile.firstName);

        if (this.profile.avatar.file) {
          formData.append('avatar', this.profile.avatar.file);
        }

        this.profile.isLoading = true;

        fetch(request, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${this.userAuthToken}`,
          },
          body: formData,
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((response) => {
            if (response.status) {
              this.alert = {
                type: 'success',
                message: '¡Información actualizada exitosamente!',
              };

              this.profile.avatar.url = response.data?.avatar;

              this.isChangedProfile = false;
            } else {
              this.alert = {
                type: 'danger',
                message: response.message,
              };
            }
          })
          .catch((error) => {
            let errorMessage = '';

            try {
              errorMessage = JSON.parse(error.message)?.message;
            } catch (err) {
              errorMessage = error.message;
            }

            this.alert = {
              type: 'danger',
              message: errorMessage,
            };
          })
          .finally(() => {
            this.profile.isLoading = false;
          });
      }
    },
    updatePassword() {
      this.$v.password.$touch();

      if (!this.$v.password.$invalid) {
        const request = `${process.env.VUE_APP_API}/users/${this.userData.id}/profile/password`;

        this.password.isLoading = true;

        fetch(request, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.userAuthToken}`,
          },
          body: JSON.stringify({
            current: this.password.current,
            new: this.password.new,
          }),
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((response) => {
            if (response.status) {
              this.alert = {
                type: 'success',
                message: '¡Contraseña actualizada exitosamente!',
              };

              this.isChangedPassword = false;

              window.setTimeout(() => {
                this.logOut();

                window.location.href = '/?auth=login';
              }, 5000);
            } else {
              this.alert = {
                type: 'danger',
                message: response.message,
              };
            }
          })
          .catch((error) => {
            let errorMessage = '';

            try {
              errorMessage = JSON.parse(error.message)?.message;
            } catch (err) {
              errorMessage = error.message;
            }

            this.alert = {
              type: 'danger',
              message: errorMessage,
            };
          })
          .finally(() => {
            this.password.isLoading = false;
          });
      }
    },
  },
};
</script>
